<template>
  <a
    :href="`#social`"
    @click="onClickAnchor"
    class="button outlined"
  >{{ $c('Поделиться') }}</a>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
@Component({
  components: {}
})
class Social extends Vue {
  onClickAnchor (e) {
    const href = e.target.href
    const anchor = href.split('#').pop()
    const el = document.querySelector(`#${anchor}`)
    if (el) {
      el.scrollIntoView({ block: 'center', behavior: 'smooth' })
    }
  }
}
export default Social
</script>
